import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES } from 'constant';
import AthenaCrudRequestList from './submodules/list/List';
import AthenaUpdateDetails from './submodules/edit/athenaDetails';
import AthenaCrudDetails from './submodules/create/athenaDetails';
import { EAthenaDashboardResources } from '../helper';
import AthenaViewDetails from './submodules/view/athenaDetails';
import AthenaCrudRequestVersionHistoryList from './submodules/versionHistory/List';

const ListAthenaCrudRequestDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				configResourceName={EAthenaDashboardResources.REQUEST_LIST}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].listAthenaCrudRequest}
				configPageName={DASHBOARD_RESOURCES.athenaDashboard}
				path={`${path}/list`}
				component={AthenaCrudRequestList}
				exact
			/>
			<AuthorizedRoute
				configResourceName={EAthenaDashboardResources.REQUEST_LIST}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].createAthenaCrudRequest}
				configPageName={DASHBOARD_RESOURCES.athenaDashboard}
				path={`${path}/create`}
				component={AthenaCrudDetails}
				exact
			/>
			<AuthorizedRoute
				configResourceName={EAthenaDashboardResources.REQUEST_LIST}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].editAthenaCrudRequest}
				configPageName={DASHBOARD_RESOURCES.athenaDashboard}
				path={`${path}/edit`}
				component={AthenaUpdateDetails}
				exact
			/>
			<AuthorizedRoute
				configResourceName={EAthenaDashboardResources.REQUEST_LIST}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].createAthenaCrudRequest}
				configPageName={DASHBOARD_RESOURCES.athenaDashboard}
				path={`${path}/view`}
				component={AthenaViewDetails}
				exact
			/>
			<AuthorizedRoute
				configResourceName={EAthenaDashboardResources.REQUEST_LIST}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].createAthenaCrudRequest}
				configPageName={DASHBOARD_RESOURCES.athenaDashboard}
				path={`${path}/versionHistory`}
				component={AthenaCrudRequestVersionHistoryList}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ListAthenaCrudRequestDashboard;
